import React, { useEffect, useState, useRef } from 'react';
import { ArrowUpIcon, ClockIcon, MicIcon } from 'lucide-react';
interface CopilotInputProps {
  onSend: (message: string) => void;
  placeholder?: string;
  disabled?: boolean;
  showDecorations?: boolean;
}
export function CopilotInput({
  onSend,
  placeholder = 'Tell PayKit about your product...',
  disabled,
  showDecorations = true
}: CopilotInputProps) {
  const [value, setValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 120) + 'px';
    }
  }, [value]);
  const handleSubmit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };
  return <div className="border border-border rounded-2xl bg-card shadow-sm overflow-hidden transition-shadow focus-within:shadow-md focus-within:border-primary/30" data-id="element-32">
      <div className="px-4 pt-4 pb-2" data-id="element-33">
        <textarea ref={textareaRef} value={value} onChange={e => setValue(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholder} disabled={disabled} rows={1} className="w-full resize-none bg-transparent text-sm text-foreground placeholder:text-muted-foreground/60 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed min-h-[24px] max-h-[120px]" aria-label="Chat message input" data-id="element-34" />
      </div>
      <div className="flex items-center justify-between px-4 pb-3 pt-1" data-id="element-35">
        <div className="flex items-center gap-2" data-id="element-36">
          {showDecorations && <button className="p-1.5 text-muted-foreground/50 hover:text-muted-foreground transition-colors rounded-md" aria-label="History" tabIndex={-1} type="button" data-id="element-37">
              <ClockIcon className="w-5 h-5" data-id="element-38" />
            </button>}
        </div>
        <div className="flex items-center gap-2" data-id="element-39">
          {showDecorations && <button className="p-1.5 text-muted-foreground/50 hover:text-muted-foreground transition-colors rounded-md" aria-label="Voice input" tabIndex={-1} type="button" data-id="element-40">
              <MicIcon className="w-5 h-5" data-id="element-41" />
            </button>}
          <button onClick={handleSubmit} disabled={!value.trim() || disabled} className="w-9 h-9 rounded-xl bg-primary text-primary-foreground flex items-center justify-center hover:opacity-90 transition-all disabled:opacity-30 disabled:cursor-not-allowed shadow-sm" aria-label="Send message" data-id="element-42">
            <ArrowUpIcon className="w-5 h-5" data-id="element-43" />
          </button>
        </div>
      </div>
    </div>;
}